import "./index.scss";
import {
  Accordion,
  AccordionGroup as AccordionItems,
  AccordionProps,
} from "@wise-emotions/react-accordion";
import React from "react";

export interface AccordionGroupProps {
  children:
    | React.ReactElement<AccordionProps>
    | React.ReactElement<AccordionProps>[];
}

const AccordionGroup = (props: AccordionGroupProps) => {
  const { children } = props;

  return (
    <div data-testid="accordionGroup" className="accordion-group">
      <AccordionItems>{children}</AccordionItems>
    </div>
  );
};

export default AccordionGroup;
